export default "__VITE_ASSET__Dz_cdR$t__"